/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
import { ImportantDates } from "commonAssets/components/ImportantDates";
import { createElement } from "commonAssets/lib/createElement.js";
import { i18n } from "commonAssets/js/constants";
import { capturePreservedClaimSections } from "./preserveClaimSections.js";

export class customImportantDates extends ImportantDates {
    datesList() {
        const baseHtml = super.datesList();
        const container = document.createElement("div");
        container.innerHTML = baseHtml;

        const list = container.querySelector("ul");
        if (!list) return baseHtml;

        const inStoreLi = createElement("li", { class: "list-group-item important-date", id: "in-store-benefit-dates" }, [
            createElement("time", { class: "d-block fw-bold" }, [], "June 1, 2026 – June 2, 2026"),
            createElement("span", {}, [], i18n.getTranslation("in_store_benefit_dates")),
        ]);

        list.appendChild(inStoreLi);
        return container.innerHTML;
    }

    card(
        classSelector = "card bg-light text-dark border rounded p-3 impt-dates",
        idSelector = "importantDatesCard"
    ) {
        const datesCard = createElement("div", { class: classSelector, id: idSelector }, [
            createElement("h3", { class: "text-danger text-center mb-4 card-title", id: "impt-dates-title" }, [], i18n.getTranslation("important_dates")),
            createElement("div", { class: "card-body p-0", id: "impt-dates-body" }, [], this.datesList()),
            createElement("p", { class: "mt-3 px-2 text-muted fst-italic small", id: "impt-dates-passed-note" }, [], i18n.getTranslation("deadlines_passed_note")),
        ]);
        return datesCard.outerHTML;
    }
}

export function customInitClaim(claim) {
    console.log("[Initiate claim]...");
    capturePreservedClaimSections(claim);

    const initFieldLock = (selector) => {
        const element = document.querySelector(selector);
        if (!element) return;
        if (element.value) element.disabled = true;
    };

    initFieldLock("#first_name");
    initFieldLock("#last_name");

    document.querySelector("#claimFieldsTitle")?.remove();
    document.querySelector("#claimFieldsBody")?.remove();
    document.querySelector("#transactions > div.formTitle")?.remove();
    document.querySelector("#transactions > div.mb-3.formBody")?.remove();

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // custom code goes here
    return claim;
}
